/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SignoutInputs */

const en_common_signout = /** @type {(inputs: Common_SignoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const id_common_signout = /** @type {(inputs: Common_SignoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Common_SignoutInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const common_signout = /** @type {((inputs?: Common_SignoutInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SignoutInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_signout(inputs)
	return en_common_signout(inputs)
});